import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// A public page under /<lang>/… shows that language (the URL decides, not the browser).
export default function LocaleScope({ lang, children }) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if ((i18n.resolvedLanguage || '').split('-')[0] !== lang) i18n.changeLanguage(lang);
  }, [i18n, lang]);
  return children;
}
